import { IntegrationHub } from "~/components/marketing/IntegrationHub";
import { Eyebrow, SectionTitle, TextLink } from "~/components/marketing/ui";
import { useI18n } from "~/i18n";

export const IntegrationsSection = () => {
  const { t } = useI18n();

  return (
    <section
      aria-labelledby="home-integrations"
      class="border-y border-primary-border bg-panel px-4 py-20 sm:px-6 sm:py-28 lg:px-8"
    >
      <div class="mx-auto max-w-7xl">
        <div class="flex flex-col gap-5">
          <Eyebrow label={t("marketing.home.integrations.eyebrow")} id="home-integrations" />
          <SectionTitle id="home-integrations" text={t("marketing.home.integrations.title")} />
        </div>

        <div class="mt-10">
          <IntegrationHub labelledBy="home-integrations" />
        </div>

        <div class="mt-8 flex flex-wrap items-center justify-between gap-4 border-t border-primary-border pt-6">
          <p class="text-secondary-text">{t("marketing.home.integrations.mcp_more")}</p>
          <TextLink href="/features#integrations" label={t("marketing.home.see_how")} describedBy="home-integrations" />
        </div>
      </div>
    </section>
  );
};
